var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.isUser)?_c('span',{staticClass:"heart-btn"},[_c('span',{staticClass:"content",on:{"click":_vm.heart}},[_c('span',{staticClass:"heart",on:{"click":_vm.follow}})])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }